import { ref, computed } from 'vue'

const theme = ref('light')
let initialised = false

export function useTheme() {
  if (!initialised) {
    try {
      const saved = localStorage.getItem('orch_theme')
      if (saved === 'dark') theme.value = 'dark'
    } catch (e) { /* ignore */ }
    apply(theme.value)
    initialised = true
  }

  const isDark = computed(() => theme.value === 'dark')

  function toggleTheme() {
    theme.value = theme.value === 'dark' ? 'light' : 'dark'
    apply(theme.value)
    try { localStorage.setItem('orch_theme', theme.value) } catch (e) { /* ignore */ }
  }

  function apply(t) {
    document.documentElement.setAttribute('data-theme', t)
  }

  return { theme, isDark, toggleTheme }
}
